
import { Component, Vue, Prop } from "vue-property-decorator";
import { profileApi } from "../services/api/profile/profile";
import { SelectProfileLoginQuery } from "../services/api/models/SelectProfileLoginQuery.model";

@Component({})
export default class SelectProfile extends Vue {
  @Prop() readonly modalProfile: boolean = false;
  @Prop() readonly profiles: any;
  @Prop() readonly returnUrl: any;

  private profileOption = "";
  private profileOptions = [];
  private enableAccept = true;
  private isSendProfile = false;
  private errorMessageShow = false;
  private errorMessage = "";
  private profileType = "";
  $t: any;

  async getProfileType() {
    this.profileOption = "";
    this.profileOptions = [];
    this.enableAccept = true;

    if (this.profileType === "") {
      return;
    }

    if (
      this.profiles[this.profileType] &&
      this.profiles[this.profileType]["options"] &&
      this.profiles[this.profileType]["options"].length > 0
    ) {
      this.profileOptions = this.profiles[this.profileType]["options"];
      return;
    }

    this.enableAccept = false;
  }

  async getProfileOption() {
    this.enableAccept = false;
  }

  async send() {
    this.isSendProfile = true;

    try {
      await profileApi.setSelectProfile(
        new SelectProfileLoginQuery(this.profileType, this.profileOption)
      );
      this.enableAccept = false;
    } catch (error) {
      console.log(error);
    }

    try {
      let url = this.returnUrl;
      window.location.href = url;
    } finally {
      this.isSendProfile = false;
      this.$emit("close");
    }
  }
}
